/* eslint-disable prefer-object-spread */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type CSSProperties, type FC, type JSX } from 'react';
import styled from 'styled-components';

import { sumClasses } from '../../../../utils/misc';
// eslint-disable-next-line import/no-cycle
import { camelToTitle } from '../../helpers/utils';
import { NoSelect } from '../../../../styles/mixins';

const StyledLabel = styled.label`
  ${NoSelect};
`;

export type LabelObject = {
  className?: string;
  text?: any;
  style?: CSSProperties;
  object?: JSX.Element;
};

export type FieldLabelProps = {
  label?: LabelObject;
  name: string;
  labelId?: string;
  children?: JSX.Element | JSX.Element[];
};

const FieldLabel: FC<FieldLabelProps> = ({ label, name, labelId, children }) => (
  <StyledLabel
    {...{
      id: labelId,
      htmlFor: name,
      className: sumClasses([(label && label.className) || '']),
      style: Object.assign({}, label && label.style ? label.style : {}),
      'aria-label': `${camelToTitle({ str: label && label.text, name })}`,
    }}
  >
    {children || (label && label.object ? label.object : camelToTitle({ str: label && label.text, name }))}
  </StyledLabel>
);

export default FieldLabel;
